/**
 * @module cercaliagl/view/VIsochrones
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import { MDCSlider } from '@material/slider';
import { MDCLinearProgress } from '@material/linear-progress';
import BaseView from './BaseView';
import { i18n } from '../dictionary';
import { createRadiobox, createSlider, createProgressBar, createCheckbox, } from './VUtils';
/**
 * @typedef {Object} IsochronesOptions
 * @property {string} weight Weight. `distance|time`
 * @property {number} isolevels Iso levels
 * @property {string} method Method `convexhull|concavehull`
 * @property {number} inverse Inverse `0|1`
 * @property {boolean} increment false | true
 * @property {string} net `car|bike|foot`
 */
/**
 * @enum {string}
 */
var Method = {
    CONVEXHULL: 'convexhull',
    CONCAVEHULL: 'concavehull',
};
/**
 * @enum {string}
 */
var Weight = {
    DISTANCE: 'distance',
    TIME: 'time',
};
/**
 * @enum {string}
 */
var Net = {
    CAR: 'car',
    BIKE: 'bike',
    FOOT: 'foot',
};
/**
 * @enum {any}
 */
var DefaultOptions = {
    WEIGHT: Weight.DISTANCE,
    METHOD: Method.CONCAVEHULL,
    ISOLEVELS_DIST: 10 * 1000,
    ISOLEVELS_TIME: 30 * 60 * 1000,
    INVERSE: 0,
};
/**
 * @enum {string}
 */
export var EventType = {
    SUBMIT: 'submit',
    SAVE_KML: 'savekml',
    REMOVE: 'remove',
    CLOSE: 'close',
};
/**
 * @enum {string}
 */
export var DistanceMaxValue = {
    CAR: 60,
    BIKE: 50,
    FOOT: 40,
};
/**
 * @classdesc
 */
var VIsochrones = /** @class */ (function (_super) {
    __extends(VIsochrones, _super);
    /**
     * @constructor
     */
    function VIsochrones() {
        var _this = this;
        var jqElement = $("\n      <div class=\"v-isochrones mdc-elevation--z4\">\n        <div class=\"content\">\n          ".concat(createProgressBar(), "      \n          <div class=\"title\">").concat(i18n('calculateIsochrone'), "</div>\n          <div class=\"row\">\n            <div class=\"column\">").concat(createRadiobox('net', Net.CAR, true, i18n('car'), true), "</div>\n            <div class=\"column\">").concat(createRadiobox('net', Net.BIKE, true, i18n('bicycle'), false), "</div>\n            <div class=\"column\">").concat(createRadiobox('net', Net.FOOT, true, i18n('onFoot'), false), "</div>\n          </div>\n          <div id=\"methodRow\" class=\"row\">\n            <div class=\"column\">").concat(createRadiobox('method', Method.CONVEXHULL, true, i18n('simplified'), false), "</div>\n            <div class=\"column\">").concat(createRadiobox('method', Method.CONCAVEHULL, true, i18n('detailed'), true), "</div>\n          </div>\n          <div>\n            <div class=\"btns\">\n              <button type=\"button\" class=\"mdc-icon-button weight active\" name=\"").concat(Weight.DISTANCE, "\">\n                <span class=\"mdc-icon-button__icon icon-distance\"></span>\n              </button>\n              <button type=\"button\" class=\"mdc-icon-button weight\" name=\"").concat(Weight.TIME, "\">\n                <span class=\"mdc-icon-button__icon icon-time\"></span>\n              </button>\n            </div>\n            <div class=\"sliders\">\n              <div class=\"distcar\">\n                ").concat(createSlider('distslidercar', 5, DistanceMaxValue.CAR, DefaultOptions.ISOLEVELS_DIST / 1000, true, 'km'), "\n              </div>\n              <div class=\"distbicycle\">\n                ").concat(createSlider('distsliderbicycle', 5, DistanceMaxValue.BIKE, DefaultOptions.ISOLEVELS_DIST / 1000, true, 'km'), "\n              </div>\n              <div class=\"distonfoot\">\n                ").concat(createSlider('distslideronfoot', 5, DistanceMaxValue.FOOT, DefaultOptions.ISOLEVELS_DIST / 1000, true, 'km'), "\n              </div>\n              <div class=\"time\">\n                ").concat(createSlider('timeslider', 1, 50, DefaultOptions.ISOLEVELS_TIME / (60 * 1000), true, 'min'), "\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"column incrementColumn\">").concat(createCheckbox('increment', 'contours_minutes', i18n('increments'), false), "</div>\n          </div>\n          <div class=\"row\">\n            <div class=\"column\">").concat(createRadiobox('inverse', 0, true, i18n('starting'), true), "</div>\n            <div class=\"column\">").concat(createRadiobox('inverse', 1, true, i18n('arrival'), false), "</div>\n          </div>\n        </div>\n        <div class=\"btns-footer\">\n          <button type=\"button\" class=\"mdc-icon-button save\">\n            <span class=\"mdc-icon-button__icon icon-save\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button remove\">\n            <span class=\"mdc-icon-button__icon icon-trash\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button calculate\">\n            <span class=\"mdc-icon-button__icon icon-gps\"></span>\n          </button>\n        </div>\n      </div>\n    "));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {IsochronesOptions}
         */
        _this.isochronesOptions_ = {
            weight: Weight.DISTANCE,
            method: Method.CONCAVEHULL,
            isolevels: DefaultOptions.ISOLEVELS_DIST,
            inverse: 0,
            increment: false,
            net: Net.CAR,
        };
        /**
         * @private
         * @type {MDCSlider}
         */
        _this.mdcTimeSlider_ = null;
        /**
         * @private
         * @type {MDCSlider}
         */
        _this.mdcDistSliderCar_ = null;
        _this.initialize_();
        return _this;
    }
    /**
     * @override
     */
    VIsochrones.prototype.show = function () {
        this.jqElement_.show();
        this.refreshSlidersLayout_();
    };
    /**
     * Necessary after create and after show/hide
     * @private
     */
    VIsochrones.prototype.refreshSlidersLayout_ = function () {
        this.mdcDistSliderCar_.layout();
        this.mdcDistSliderBicycle_.layout();
        this.mdcDistSliderOnFoot_.layout();
        this.mdcTimeSlider_.layout();
    };
    /**
     * @private
     */
    VIsochrones.prototype.initialize_ = function () {
        var _this = this;
        if (!this.jqElement_) {
            return;
        }
        var jqDistsSliderCar = this.jqElement_.find('.distslidercar');
        var jqDistsSliderBicycle = this.jqElement_.find('.distsliderbicycle');
        var jqDistsSliderOnFoot = this.jqElement_.find('.distslideronfoot');
        var jqTimesSlider = this.jqElement_.find('.timeslider');
        if (!jqDistsSliderCar || jqDistsSliderCar.length === 0
            || !jqDistsSliderBicycle || jqDistsSliderBicycle.length === 0
            || !jqDistsSliderBicycle || jqDistsSliderBicycle.length === 0
            || !jqTimesSlider || jqTimesSlider.length === 0) {
            return;
        }
        var incrementColumn = this.jqElement_.find('.incrementColumn');
        this.jqElement_.find('button.weight').click(function (e) {
            var buttonClicked = e.currentTarget;
            _this.jqElement_.find('button.weight').removeClass('active');
            $(buttonClicked).addClass('active');
            _this.isochronesOptions_.weight = buttonClicked.name;
            if (buttonClicked.name === Weight.DISTANCE) {
                _this.jqElement_.find('.sliders .time').hide();
                incrementColumn.css('display', 'none');
                _this.updateDistanceSliderVisibility();
                if (_this.isochronesOptions_.net === Net.CAR) {
                    _this.isochronesOptions_.isolevels = _this.mdcDistSliderCar_.getValue() * 1000;
                }
                else if (_this.isochronesOptions_.net === Net.BIKE) {
                    _this.isochronesOptions_.isolevels = _this.mdcDistSliderBicycle_.getValue() * 1000;
                }
                else {
                    _this.isochronesOptions_.isolevels = _this.mdcDistSliderOnFoot_.getValue() * 1000;
                }
            }
            else {
                _this.jqElement_.find('.sliders .distcar').hide();
                _this.jqElement_.find('.sliders .distbicycle').hide();
                _this.jqElement_.find('.sliders .distonfoot').hide();
                _this.jqElement_.find('.sliders .time').show();
                incrementColumn.css('display', 'flex');
                _this.isochronesOptions_.isolevels = _this.mdcTimeSlider_.getValue() * 60 * 1000;
            }
            _this.refreshSlidersLayout_();
        });
        this.jqElement_.find('input[name=net]').change(function (e) {
            _this.isochronesOptions_.net = e.target.value;
            if (_this.isochronesOptions_.weight === Weight.DISTANCE) {
                _this.updateDistanceSliders(_this.isochronesOptions_.isolevels / 1000, _this.isochronesOptions_.net);
                _this.updateDistanceSliderVisibility();
                _this.refreshSlidersLayout_();
            }
        });
        this.jqElement_.find('input[name=method]').change(function (e) {
            _this.isochronesOptions_.method = e.target.value;
        });
        this.jqElement_.find('input[name=inverse]').change(function (e) {
            _this.isochronesOptions_.inverse = parseInt(e.target.value, 10);
        });
        this.jqElement_.find('button.calculate').click(function () { return _this.emit(EventType.SUBMIT, _this.isochronesOptions_); }); // Calculate
        this.jqElement_.find('button.save').click(function () { return _this.emit(EventType.SAVE_KML); }); // Save
        this.jqElement_.find('button.remove').click(function () { return _this.emit(EventType.REMOVE); }); // Remove
        this.mdcDistSliderCar_ = new MDCSlider(jqDistsSliderCar.get(0));
        this.mdcDistSliderBicycle_ = new MDCSlider(jqDistsSliderBicycle.get(0));
        this.mdcDistSliderOnFoot_ = new MDCSlider(jqDistsSliderOnFoot.get(0));
        this.mdcTimeSlider_ = new MDCSlider(jqTimesSlider.get(0));
        this.mdcDistSliderCar_.listen('MDCSlider:change', function () {
            _this.updateDistanceSliders(_this.mdcDistSliderCar_.getValue(), Net.CAR);
        });
        this.mdcDistSliderBicycle_.listen('MDCSlider:change', function () {
            _this.updateDistanceSliders(_this.mdcDistSliderBicycle_.getValue(), Net.BIKE);
        });
        this.mdcDistSliderOnFoot_.listen('MDCSlider:change', function () {
            _this.updateDistanceSliders(_this.mdcDistSliderOnFoot_.getValue(), Net.FOOT);
        });
        this.mdcTimeSlider_.listen('MDCSlider:change', function () {
            _this.isochronesOptions_.isolevels = _this.mdcTimeSlider_.getValue() * 60 * 1000; // in milliseconds
            _this.jqElement_.find('.sliders .timeslider .value').text("".concat(_this.mdcTimeSlider_.getValue(), "min"));
        });
        this.jqElement_.find('input[name=increment]').change(function (e) {
            _this.isochronesOptions_.increment = e.target.checked;
            if (e.target.checked) {
                _this.mdcTimeSlider_.setValue(15);
                _this.isochronesOptions_.isolevels = 15 * 60 * 1000;
                // this.mdcTimeSlider_.root.setAttribute('aria-valuemax', '30');
                // this.jqElement_.find('.timeslider .slider__thumb ').attr('aria-valuemax', '30');
                _this.mdcTimeSlider_.setDisabled(true);
                var span = _this.jqElement_.find('.time .mdc-slider__thumb span.value');
                span.text('15min');
            }
            else {
                _this.mdcTimeSlider_.setDisabled(false);
            }
        });
        new MDCLinearProgress(this.jqElement_.find('.progressbar').get(0)); // eslint-disable-line no-new
    };
    /**
     * @param {boolean} show Show
     */
    VIsochrones.prototype.setLoading = function (show) {
        var jqLoading = this.jqElement_.find('.progressbar');
        if (show) {
            jqLoading.show();
        }
        else {
            jqLoading.hide();
        }
    };
    /**
     * @param {boolean} drawn Drawn
     */
    VIsochrones.prototype.setDrawn = function (drawn) {
        var jqSaveBtn = this.jqElement_.find('button.save');
        var jqRemoveBtn = this.jqElement_.find('button.remove');
        if (drawn) {
            jqSaveBtn.show();
            jqRemoveBtn.show();
        }
        else {
            jqSaveBtn.hide();
            jqRemoveBtn.hide();
        }
    };
    /**
     * @private
     */
    VIsochrones.prototype.updateDistanceSliderVisibility = function () {
        if (this.isochronesOptions_.net === Net.CAR) {
            this.jqElement_.find('#methodRow').show();
            this.jqElement_.find('.sliders .distbicycle').hide();
            this.jqElement_.find('.sliders .distonfoot').hide();
            this.jqElement_.find('.sliders .distcar').show();
        }
        else if (this.isochronesOptions_.net === Net.BIKE) {
            this.jqElement_.find('#methodRow').hide();
            this.jqElement_.find('.sliders .distcar').hide();
            this.jqElement_.find('.sliders .distonfoot').hide();
            this.jqElement_.find('.sliders .distbicycle').show();
        }
        else {
            this.jqElement_.find('#methodRow').hide();
            this.jqElement_.find('.sliders .distcar').hide();
            this.jqElement_.find('.sliders .distbicycle').hide();
            this.jqElement_.find('.sliders .distonfoot').show();
        }
    };
    /**
     * @private
     * @param {number} value newValue
     * @param {string} net `car|bike|foot`
     */
    VIsochrones.prototype.updateDistanceSliders = function (value, net) {
        var bicycleValue = value > DistanceMaxValue.BIKE ? DistanceMaxValue.BIKE : value;
        var onFootValue = value > DistanceMaxValue.FOOT ? DistanceMaxValue.FOOT : value;
        if (net !== Net.CAR) {
            this.mdcDistSliderCar_.setValue(value);
        }
        else {
            this.isochronesOptions_.isolevels = value * 1000;
            this.jqElement_.find('.sliders .distslidercar .value').text("".concat(value, "km"));
        }
        if (net !== Net.BIKE) {
            this.mdcDistSliderBicycle_.setValue(bicycleValue);
        }
        else {
            this.isochronesOptions_.isolevels = bicycleValue * 1000;
            this.jqElement_.find('.sliders .distsliderbicycle .value').text("".concat(bicycleValue, "km"));
        }
        if (net !== Net.FOOT) {
            this.mdcDistSliderOnFoot_.setValue(onFootValue);
        }
        else {
            this.isochronesOptions_.isolevels = onFootValue * 1000;
            this.jqElement_.find('.sliders .distslideronfoot .value').text("".concat(onFootValue, "km"));
        }
    };
    return VIsochrones;
}(BaseView));
export default VIsochrones;
//# sourceMappingURL=VIsochrones.js.map